<template>
    <div>
        <app-modal 
            :show="show" 
            @close="close"
            width="md:w-1/2 lg:w-1/3"
        >
            <template slot="header">ABR Lookup</template>
            <template slot="body">
                <app-input
                    v-model="searchForm.q"
                    placeholder="Name / ABN / ACN"
                    :error="searchForm.errors.get('q')"
                    @updated="searchForm.errors.clear('q')"
                    focus
                    required
                    @keyup.enter.native="check"
                />
                <div class="flex items-center justify-end mt-5">
                    <app-button 
                        class="btn-white"
                        @click="close"
                        :disable="checking"
                    >Cancel</app-button>
                    <app-button 
                        class="btn-blue ml-2"
                        @click="check"
                        :loading="checking"
                    >Check</app-button>
                </div>
            </template>
        </app-modal>
        <app-modal 
            :show.sync="showDomainInfoModal" 
            width="md:w-1/2 lg:w-1/3"
            @close="() => { this. businesses = []; }"
        >
            <template slot="header">
                <div class="flex items-center">
                    <app-button 
                        class="btn-gray btn-sm mr-3" 
                        v-if="!showBusinesses && businesses.length > 0"
                        @click="showBusinesses = true"
                    ><arrow-back width="18px" height="18px"/></app-button>
                    <span>Business Info</span>
                </div>
            </template>
            <template slot="body">
                <table class="table" v-if="businesses && showBusinesses">
                    <tr v-for="(business) in businesses"
                        :key="business.Abn"
                    >
                        <td class="overflow-visible">
                            {{ business.Name }}<br>
                            <span class="text-gray-600">{{ business.Abn }}</span>
                        </td>
                        <td class="text-right overflow-visible" width="120">
                            <app-button 
                                class="btn-blue"
                                @click="check(business.Abn)"
                                :loading="checking && business.Abn == abnBeingCheck"
                                :disable="checking"
                            >Check</app-button>
                        </td>
                    </tr>
                </table>
                <table class="table" v-else>
                    <tr>
                        <td width="80"><b>Name</b></td>
                        <td class="overflow-visible">{{ info.EntityName }}</td>
                    </tr>
                    <tr>
                        <td><b>ABN</b></td>
                        <td>{{ info.Abn }}</td>
                    </tr>
                    <tr v-if="info.Acn">
                        <td><b>ACN</b></td>
                        <td>{{ info.Acn }}</td>
                    </tr>
                    <tr>
                        <td><b>Status</b></td>
                        <td>{{ info.AbnStatus }}</td>
                    </tr>
                    <tr>
                        <td><b>Type</b></td>
                        <td class="overflow-visible">{{ info.EntityTypeName }}</td>
                    </tr>
                </table>
            </template>
        </app-modal>
    </div>
</template>

<script>
import Form from '@/helpers/Form';
import Http from '@/helpers/Http';

export default {
    components: {
        ArrowBack: () => import('@/icons/ArrowBack.vue')
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        }
    },
    data() {
        return {
            showDomainInfoModal: false,
            info: {},
            checking: false,
            searchForm: new Form({
                q: null,
            }),
            abnBeingCheck: null,
            businesses: [],
            showBusinesses: false,
        }
    },
    methods: {
        close() {
            this.$emit('update:show', false);
            this.$emit('close');
            this.searchForm.reset();
            this.searchForm.errors.clear();            
        },
        check(abn) {
            this.searchForm.errors.clear();
            this.checking = true;
            this.abnBeingCheck = abn;
            Http.get(`tools/abr_lookup`, {
                    params: (abn && typeof abn != 'object') ? {q: abn} : this.searchForm.payload()
                })
                .then(({data}) => {
                    this.checking = false;
                    this.showDomainInfoModal = true;
                    this.info = data;
                    this.showBusinesses = false;

                    if (data.Names) {
                        this.businesses = data.Names;
                        this.showBusinesses = true;
                    }

                    this.close();
                })
                .catch(({response}) => {
                    this.checking = false;
                    this.searchForm.errors.record(response.data);
                })
        },
    }
}
</script>